/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Background_SignatureInputs */

const en_background_signature = /** @type {(inputs: Background_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background Signature`)
};

const id_background_signature = /** @type {(inputs: Background_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latar Belakang Khas`)
};

/** @type {(inputs: Background_SignatureInputs) => LocalizedString} */
const es_background_signature = en_background_signature;

/** @type {(inputs: Background_SignatureInputs) => LocalizedString} */
const fr_background_signature = en_background_signature;

/** @type {(inputs: Background_SignatureInputs) => LocalizedString} */
const de_background_signature = en_background_signature;

/** @type {(inputs: Background_SignatureInputs) => LocalizedString} */
const ja_background_signature = en_background_signature;

/** @type {(inputs: Background_SignatureInputs) => LocalizedString} */
const zh_background_signature = en_background_signature;

/** @type {(inputs: Background_SignatureInputs) => LocalizedString} */
const ar_background_signature = en_background_signature;

/** @type {(inputs: Background_SignatureInputs) => LocalizedString} */
const it_background_signature = en_background_signature;

/** @type {(inputs: Background_SignatureInputs) => LocalizedString} */
const ru_background_signature = en_background_signature;

/** @type {(inputs: Background_SignatureInputs) => LocalizedString} */
const pt_background_signature = en_background_signature;

/** @type {(inputs: Background_SignatureInputs) => LocalizedString} */
const ko_background_signature = en_background_signature;

/**
* | output |
* | --- |
* | "Background Signature" |
*
* @param {Background_SignatureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const background_signature = /** @type {((inputs?: Background_SignatureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Background_SignatureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_background_signature(inputs)
	if (locale === "es") return es_background_signature(inputs)
	if (locale === "fr") return fr_background_signature(inputs)
	if (locale === "de") return de_background_signature(inputs)
	if (locale === "ja") return ja_background_signature(inputs)
	if (locale === "zh") return zh_background_signature(inputs)
	if (locale === "ar") return ar_background_signature(inputs)
	if (locale === "id") return id_background_signature(inputs)
	if (locale === "it") return it_background_signature(inputs)
	if (locale === "ru") return ru_background_signature(inputs)
	if (locale === "pt") return pt_background_signature(inputs)
	return ko_background_signature(inputs)
});